import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import GeneralModal from '../../../components/Modal/GeneralModal';
import ConfirmModal from '../../../components/Modal/ConfirmModal';
import ChooseRestaurantModal from '../../../pages/Order/OrderManagement/components/ChooseRestaurantModal';
import { clearConfirm, clearGeneralError } from './actions';

const HasAuthenticate = ({ isAuthenticate, children }) => (
  <React.Fragment>{isAuthenticate ? children : null}</React.Fragment>
);

class UniversalModals extends React.Component {
  render() {
    const {
      authenticated,
      universalModal,
      clearGeneralErrorConnect,
      clearConfirmConnect,
      isReady,
    } = this.props;
    const { error, confirm, chooseRestaurant } = universalModal;
    return (
      <React.Fragment>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          closeOnClick
          pauseOnVisibilityChange
          pauseOnHover
        />
        <GeneralModal
          open={error.isShow}
          message={error.message}
          onClose={clearGeneralErrorConnect}
          extraData={error.extraData}
        />
        <ConfirmModal
          open={confirm.isOpen}
          title={confirm.title}
          message={confirm.message}
          onOk={confirm.onOk}
          onCancel={confirm.onCancel}
          onClose={clearConfirmConnect}
        />
        <HasAuthenticate isAuthenticate={authenticated && isReady}>
          <ChooseRestaurantModal
            handleRefreshList={chooseRestaurant.refreshList}
            isShowAllRestaurantOption={
              chooseRestaurant.isShowAllRestaurantOption
            }
          />
        </HasAuthenticate>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  isReady: state.app.isReady,
  metadata: state.app.metadata,
  universalModal: state.universalModal,
});

const mapDispatchToProps = dispatch => ({
  clearGeneralErrorConnect: () => {
    dispatch(clearGeneralError());
  },
  clearConfirmConnect: () => {
    dispatch(clearConfirm());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(UniversalModals),
);



// WEBPACK FOOTER //
// ./foody/src/layout/components/UniversalModal/UniversalModals.jsx